var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"emoji",staticClass:"modal bottom-sheet"},[_c('picker',{style:(_vm.customStyle),attrs:{"show-search":false,"show-preview":false,"data":_vm.emojiData,"set":"facebook"},on:{"select":_vm.onReacted}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }